import {
  BlankSlate,
  BlankSlateActions,
  BlankSlateIcon,
  BlankSlateTitle,
  Button,
  Card,
  CardContent,
  CardHeader,
} from "@prismicio/editor-ui"

import { ImageFieldTitle } from "./ImageFieldTitle"

interface EmptyCardContentProps {
  fieldLabel: string
  isUpdating: boolean
  readOnly: boolean
  onMediaDialogOpenChange: (open: boolean) => void
}

export function EmptyCardContent(props: EmptyCardContentProps) {
  const { fieldLabel, isUpdating, readOnly, onMediaDialogOpenChange } = props

  return (
    <>
      <CardHeader sx={{ flexWrap: "wrap" }}>
        <ImageFieldTitle fieldLabel={fieldLabel} />
      </CardHeader>
      <CardContent>
        <Card
          color="grey2"
          variant="dashed"
          paddingBlock={12}
          radius={4}
          sx={{ width: "100%" }}
        >
          <CardContent>
            <BlankSlate variant="horizontal">
              <BlankSlateIcon
                name="cloudUpload"
                lineColor="purple9"
                backgroundColor="purple4"
                size="small"
              />
              <BlankSlateTitle>
                {isUpdating
                  ? "Preparing your image..."
                  : "You haven't selected an image"}
              </BlankSlateTitle>
              {!readOnly && (
                <BlankSlateActions>
                  <Button
                    disabled={isUpdating}
                    onClick={() => onMediaDialogOpenChange(true)}
                    size="medium"
                  >
                    Select image
                  </Button>
                </BlankSlateActions>
              )}
            </BlankSlate>
          </CardContent>
        </Card>
      </CardContent>
    </>
  )
}
